import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
// import { Provider } from './context/countries';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <Provider>
  <StrictMode>
    <BrowserRouter basename="/NationNavigator">
      <App />
    </BrowserRouter>
  </StrictMode>
  // </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
